<template>
    <div class="mt-5">
        <b-container>
            <b-row>
                <b-col
                    cols="8"
                    offset="2"
                    lg="6"
                    offset-lg="3"
                >
                    <b-card class="shadow p-5">
                        <h3 class="text-center mb-3">Reiniciar Contraseña</h3>
                        <p class="mt-5">
                            Por favor, ingrese una nueva contraseña.
                        </p>

                        <b-form
                            @submit.stop.prevent="onSubmit"
                            class="mt-4"
                        >
                            <b-form-group
                                id="input-group-password"
                                label="*Nueva contraseña:"
                                label-for="input-password"
                            >
                                <b-form-input
                                    id="input-password"
                                    v-model="$v.form.password.$model"
                                    type="password"
                                    required
                                    :disabled="formDisabled"
                                    :state="validateState('password')"
                                />
                                <b-form-invalid-feedback id="input-password-feedback">
                                    Este campo es requerido y debe tener un mínimo de 6 caracteres.
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group
                                id="input-group-confirm"
                                label="*Repetir contraseña:"
                                label-for="input-confirm"
                            >
                                <b-form-input
                                    id="input-confirm"
                                    v-model="$v.form.confirm.$model"
                                    type="password"
                                    required
                                    :disabled="formDisabled"
                                    :state="validateState('confirm')"
                                />
                                <b-form-invalid-feedback id="input-confirm-feedback">
                                    Este campo es requerido y debe ser igual a la contraseña.
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <div class="text-center pt-4">
                                <b-button
                                    type="submit"
                                    variant="primary"
                                    size="lg"
                                    :disabled="formDisabled || $v.form.$invalid"
                                >
                                    Cambiar
                                </b-button>
                            </div>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
    name: 'ResetPassword',
    data () {
        return {
            formDisabled: false,
            resetToken: this.$route.params.resetToken,
            form: {
                password: '',
                confirm: ''
            }
        }
    },
    watch: {
        '$route' (to, from) {
            this.resetToken = to.params.resetToken
        }
    },
    validations: {
        form: {
            password: {
                required,
                minLen: minLength(6)
            },
            confirm: {
                required,
                sameAs: sameAs('password')
            }
        }
    },
    methods: {
        ...mapActions([
            'resetPassword'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async onSubmit () {
            const newPassword = this.form.password
            const resetToken = this.resetToken
            console.log('onSubmit resetToken:', resetToken)
            try {
                this.formDisabled = true
                await this.resetPassword({ password: newPassword, resetToken: resetToken })
                this.$root.infoToast('Su contraseña ha sido cambiada satisfactoriamente.', 'Reinicio de Contraseña Exitoso')
                this.formDisabled = false
                this.$router.push({ name: 'login' })
            } catch (err) {
                console.log(err)
                if (err.response) {
                    switch (err.response.status) {
                    case 400:
                        this.$root.dangerToast('La contraseña debe tener un mínimo de 6 caracteres.', 'Error de Validación!')
                        this.formDisabled = false
                        return
                    case 401:
                        this.$root.dangerToast('El token de reinicio de contraseña es inválido.')
                        this.formDisabled = false
                        this.$router.push({ name: 'home' })
                        break
                    }
                } else {
                    this.unknownErrorToast()
                    this.formDisabled = false
                }
            }
        }
    }
}
</script>
